var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0C3.36445 0 0 3.14016 0 7C0 8.84564 0.802116 10.6209 2.21741 11.9429L0.242958 14H7.5C11.6356 14 15 10.8598 15 7C15 3.14016 11.6356 0 7.5 0ZM7.5 13.0667H2.39376L3.54343 11.8688L3.14163 11.5417C1.70357 10.3715 0.878906 8.71609 0.878906 7C0.878906 3.65483 3.84911 0.933333 7.5 0.933333C11.1509 0.933333 14.1211 3.65483 14.1211 7C14.1211 10.3452 11.1509 13.0667 7.5 13.0667Z",
  fill: "#989AA1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 13.0667H2.39376L3.54343 11.8688L3.14163 11.5417C1.70357 10.3715 0.878906 8.71609 0.878906 7C0.878906 3.65483 3.84911 0.933333 7.5 0.933333C11.1509 0.933333 14.1211 3.65483 14.1211 7C14.1211 10.3452 11.1509 13.0667 7.5 13.0667Z",
  fill: "#989AA1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.76495 7.91957L4.29883 10.3945L6.62942 9.8995L11.2088 5.03645L9.34441 3.05664L4.76495 7.91957ZM6.19603 9.0397L5.4192 9.20473L5.57462 8.3798L8.10136 5.69647L8.72288 6.35648L6.19603 9.0397ZM9.3443 5.69647L8.72288 5.03657L9.3443 4.37655L9.96583 5.03657L9.3443 5.69647Z",
  fill: "white"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3d9608e8.svg";
export { ForwardRef as ReactComponent };